<template>
    <div>
    <module-card title="筛选">
      <el-form :inline="true" :model="searchForm">
        <el-form-item label="创建时间">
          <date-range-picker :value="createTime" @change="value => createTime = value" ref="createTime" @getChange="dateChange"></date-range-picker>
        </el-form-item>
        <el-form-item label="文件名称">
           <el-input v-model="searchForm.fileName" placeholder="请输入文件名称" :clearable="true"/>
        </el-form-item>
        <el-form-item label="状态">
          <el-select clearable v-model="searchForm.status" class="selectWidth">
            <el-option label="已完成" :value="1"></el-option>
            <el-option label="生成中" :value="0"></el-option>
            <el-option label="失败" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类别">
          <el-select clearable v-model="searchForm.moduleCode" class="selectWidth">
            <el-option label="补贴对账" :value="0"></el-option>
            <el-option label="其他" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-button
              icon="el-icon-search"
              @click="search"
              :loading="searchLoading"
              type="primary"
            >
              查询
            </el-button>
        </el-form-item>
      </el-form>
    </module-card>
    <module-card title="下载中心">
      <div class="info">提示：一次最多导出10万条记录；</div>
      <el-table class="table" border :data="list" v-loading="searchLoading">
        <el-table-column
          prop="createTime"
          label="创建时间">
        </el-table-column>
        <el-table-column
          prop="fileName"
          label="文件名称">
        </el-table-column>
        <el-table-column
          prop="userName"
          label="操作人">
        </el-table-column>
        <el-table-column
          prop="moduleName"
          label="类别"
          width="100">
        </el-table-column>
        <el-table-column
          label="状态" width="100">
          <template slot-scope="scope">
            <span>{{getStatusText(scope.row.status)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="300"
          :context="_self">
          <template slot-scope="scope">
            <auth-button auth-type="span" opt="downloadRecord" v-if="scope.row.status == 1" @click.native="handleDown(scope.row)" label="下载"></auth-button>
            <auth-button auth-type="span" opt="send_email" v-if="!scope.row.downloadRecord && scope.row.status == 1" @click.native="handleSendEmail(scope.row)" label="发送邮件"></auth-button>
            <auth-button auth-type="span" opt="send_email" class="gray" v-if="scope.row.downloadRecord && scope.row.status == 1" label="已发送"></auth-button>
            <auth-button auth-type="span" opt="deleteRecord" @click.native="handleDelete(scope.row)" label="删除"></auth-button>
            <auth-button v-if="scope.row.emailPassword" auth-type="span" opt="viewPassword" @click.native="handleViewPassWord(scope.row)" label="查看密码"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </module-card>
    <el-col :span="24" class="btm-action">
      <pagination @changePage="onChangeCurrentPage" :count="searchForm.count" :page-no="searchForm.pageNo"></pagination>
    </el-col>
  </div>
</template>

<script>
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { createDownLink } from '@/assets/js/utils'
export default {
  name: 'downloadCenter',
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    return {
      searchLoading: false,
      createTime: [],
      searchForm: {
        createTimeStart: '',
        createTimeEnd: '',
        status: '',
        moduleCode: '', // 0-补贴对账 1-其他
        pageNo: 1,
        fileName: '',
        count: 0,
        pageSize: 20
      },
      list: [],
      // 0-生成中  1-已完成  2-失败
      statusList: [
        {
          status: 0,
          text: '生成中'
        }, {
          status: 1,
          text: '已完成'
        }, {
          status: 2,
          text: '失败'
        }
      ],
      email: ''
    }
  },
  mounted () {
    this.getList()
    this.getEmail()
  },
  methods: {
    /**
         * @description 日期组件选中事件
         * @param  {String} value 当前结果
         */
    dateChange (value) {
      this.createTime = value
    },
    /**
         * @description 点击查询
         */
    search () {
      this.searchForm.pageNo = 1
      this.getList()
    },
    /**
         * @description 列表请求
         */
    getList () {
      this.searchForm.createTimeStart = this.createTime && this.createTime[0] ? this.createTime[0] : ''
      this.searchForm.createTimeEnd = this.createTime && this.createTime[1] ? this.createTime[1] : ''
      this.searchLoading = true
      this.$axios.post(this.$api.downloadList, this.searchForm).then(res => {
        this.searchLoading = false
        if (res.respCode === '0') {
          this.searchForm.count = res.data.count
          this.list = res.data.list
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          })
        }
      })
    },
    /**
         * @description 改变当前页事件
         * @param  {Object} value 当前结果
         */
    onChangeCurrentPage (value) {
      this.searchForm.pageNo = value
      this.getList()
    },
    /**
     * @description 下载选中报表
     * @param  {Object} row 当前行
     */
    handleDown (row) {
      this.$axios.post(this.$api.downloadRecord, { id: row.id }, {
        responseType: 'blob'
      }).then(res => {
        if ((res && res.respCode) || !res) {
          return
        }
        createDownLink(res, row.fileName)
      })
    },
    /**
     * @description 删除选中报表
     * @param  {Object} row 当前行
     */
    handleDelete (row) {
      const that = this
      this.$confirm('是否确认删除选中报表？', {
      }).then(() => {
        this.$axios.post(this.$api.deleteRecord, {
          id: row.id,
          status: 3
        }).then(res => {
          if (res.respCode === '0') {
            that.$message({
              message: '删除成功',
              type: 'success'
            })
            that.getList()
          } else {
            that.$message({
              message: res.respMsg,
              type: 'error'
            })
          }
        })
      })
    },
    handleViewPassWord (row) {
      // console.log('查看密码', row)
      // this.$axios.post(this.$api.viewPassword, { id: row.id }).then(res => {
      //   const psw = res.data
      //   this.$confirm(`文件密码为：${psw}`, {
      //     confirmButtonText: '我知道了',
      //     showClose: false,
      //     showCancelButton: false,
      //     center: true
      //   })
      // })
      this.$confirm(`文件密码为：${row.emailPassword}`, {
        confirmButtonText: '我知道了',
        showClose: false,
        showCancelButton: false,
        center: true
      })
    },
    getStatusText (status) {
      const result = this.statusList.filter(item => {
        return item.status === status
      })
      if (result.length === 1) {
        return result[0].text
      } else {
        return '未知'
      }
    },
    /**
     * @description 发送邮件
     * @param  {Object} row 当前行
     */
    handleSendEmail (row) {
      if (this.email) {
        const that = this
        this.$confirm(`文件将发送至邮箱${this.email}，请注意查收。`, {
          confirmButtonText: '确认发送'
        }).then(() => {
          // 发送邮件
          that.$axios.post(that.$api.sendEmail, {
            id: row.id
          }).then(res => {
            if (res.respCode === '0') {
              that.$confirm('邮件已发送，请注意查收', {
                confirmButtonText: '确定',
                showCancelButton: false
              }).then(() => {
                that.getList()
              })
            }
          })
        })
      } else {
        this.$confirm('未配置有效邮箱，请联系乐刷运营配置邮箱后操作。', {
          confirmButtonText: '确定',
          showCancelButton: false
        }).then(() => {
        })
      }
    },
    getEmail () {
      this.$axios.get(this.$api.getEmail).then(res => {
        if (res.respCode === '0') {
          this.email = res.data
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.info{
  margin-bottom: 15px;
  color: red;
}
.gray{
  /deep/ span{
    color: gray;
  }
}
</style>
